(() => {
  const PRELOADED = 'data-deliving-preview-preloaded';

  const getNextPreviewImage = (card) => {
    const activeSlide = card.querySelector('slideshow-slide[aria-hidden="false"]');
    if (!activeSlide) return null;
    const nextSlide = activeSlide.nextElementSibling;
    if (!nextSlide?.matches('slideshow-slide')) return null;
    return nextSlide.querySelector('img');
  };

  const restoreLazy = (card) => {
    if (!(card instanceof HTMLElement) || card.hasAttribute(PRELOADED)) return;
    const image = getNextPreviewImage(card);
    if (image instanceof HTMLImageElement && !image.hasAttribute('loading')) {
      image.setAttribute('loading', 'lazy');
    }
  };

  const preloadForInteraction = (card) => {
    if (!(card instanceof HTMLElement) || card.hasAttribute(PRELOADED)) return;
    card.setAttribute(PRELOADED, 'true');
    const image = getNextPreviewImage(card);
    if (image instanceof HTMLImageElement) image.removeAttribute('loading');
  };

  const prepareCard = (card) => {
    if (!(card instanceof HTMLElement) || card.dataset.delivingPreviewPrepared === 'true') return;
    card.dataset.delivingPreviewPrepared = 'true';

    card.addEventListener(
      'pointerenter',
      (event) => {
        if (event.pointerType === 'mouse') preloadForInteraction(card);
      },
      { capture: true }
    );
    card.addEventListener('focusin', () => preloadForInteraction(card), { capture: true });

    queueMicrotask(() => restoreLazy(card));
    setTimeout(() => restoreLazy(card), 0);
    setTimeout(() => restoreLazy(card), 100);
  };

  const init = () => {
    const results = document.querySelector('#ResultsList');
    if (!results) return;

    results.querySelectorAll('product-card').forEach(prepareCard);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) continue;
            if (node.matches('product-card')) prepareCard(node);
            node.querySelectorAll?.('product-card').forEach(prepareCard);
          }
          continue;
        }

        if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
          const card = mutation.target.closest('product-card');
          if (!card || card.hasAttribute(PRELOADED)) continue;
          if (getNextPreviewImage(card) === mutation.target && !mutation.target.hasAttribute('loading')) {
            mutation.target.setAttribute('loading', 'lazy');
          }
        }
      }
    });

    observer.observe(results, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['loading'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
